import React from 'react'

const AboutIcon = () => {
    return (
        <div className='AboutIcon DesktopIcon'>
            <img
                // src='/images/AboutIcon.png'
                src='/images/Finalized/AboutIcon.png'
                alt='About'
                draggable={false}
                onDragStart={(e) => e.preventDefault()}
            />
            <span>About</span>
        </div>
    )
}

export default AboutIcon